module.exports = __webpack_public_path__ + "img/header-7.76099e67.jpg";